import { FC, Suspense } from 'react';
import { useAtomValue } from 'jotai';
import { $CurrentPOIInfoOrNull } from '@poi/shared/current-poi-info';
import { POIInfo } from '@poi/body/info';
import { POIPosts } from '@poi/body/posts';
import { NotFound } from '~/components/not-found';
import { PoiSilentAwaken, PoiSilentAwakenV2 } from './poi-silent-awaken';
import { $LibraOptimizeSilentAwaken } from '~/utils/libra/streaming';

export const POIBody: FC = () => {
  const poi = useAtomValue($CurrentPOIInfoOrNull);
  const optimizeSilentAwaken = useAtomValue($LibraOptimizeSilentAwaken);

  if (poi) {
    return (
      <>
        {optimizeSilentAwaken ? <PoiSilentAwakenV2 /> : <PoiSilentAwaken />}
        <POIInfo />
        <Suspense>
          <POIPosts />
        </Suspense>
      </>
    );
  }

  return <NotFound />;
};
